/* eslint-disable no-alert */
import React from "react";
import PropTypes from "prop-types";
import newRelicErrorReport from "src/utils/newRelic/newRelicErrorReport";

class GlobalErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("App crashed:", error, errorInfo);
    this.setState({ errorInfo });
    newRelicErrorReport(
      error,
      `GLOBAL ERROR BOUNDARY-stack:${errorInfo.componentStack}`
    );
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="d-flex flex-column align-items-center justify-content-center vh-100">
          <h1>Coś poszło nie tak / Something went wrong</h1>
          <p className="mt-2">
            Skontaktuj się z administratorem / Please contact support and share
            the details below
          </p>

          <pre className="p-4 mt-4 text-start">
            {this.state.error?.toString()}
            {"\n"}
            {this.state.errorInfo?.componentStack}
          </pre>

          <button
            type="button"
            className="mt-4 px-4 py-2 btn btn-primary"
            onClick={() => {
              navigator.clipboard.writeText(
                `${this.state.error?.toString()}\n${
                  this.state.errorInfo?.componentStack
                }`
              );
              alert(
                "Dane błędu skopiowane / Error details copied to clipboard!"
              );
            }}
          >
            Skopiuj szczegóły błędu / Copy Error Details
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

GlobalErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
};

export default GlobalErrorBoundary;
